import { render, staticRenderFns } from "./areas.vue?vue&type=template&id=4c537d48&scoped=true"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c537d48",
  null
  
)

export default component.exports